import React, { Fragment, useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import axios from 'axios';
import { useFormik } from 'formik';
import { executiveSchema } from '../schemas';
import BlankImage from '../assets/Blank.png'
import { useSelector } from 'react-redux';
import NewStaffAdvisers from './NewStaffAdvisers';

const NewExecutive = ()=>{
    const uri = useSelector(state=>state.uri)
    const [executives, setExecutives] = useState([])
    const [dialog, setDialog] = useState(false)
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [fileSize, setFileSize] = useState('')
    const [staff, setStaff] = useState([])

    const {handleChange, handleBlur, handleReset, handleSubmit, errors, touched, values} = useFormik({
        initialValues: {
            fullname: '',
            photo: '',
            office: '',
            deptLevel: '',      
        },
        validationSchema: executiveSchema,
        onSubmit: (values)=>{            
            setIsSubmitting(true)
            axios.put(
                `${uri}executives`,
                values
            ).then(res=>{
                setFileSize('')
                handleReset()
                setIsSubmitting(false)
                fetchData()
                setDialog(false)
            }).catch(err=>{
                setIsSubmitting(false)
                console.log(err)
            })
        }
    })

    useEffect(()=>{
        fetchData()
    }, [])

    const fetchData = ()=>{
        axios.get(
            `${uri}executives`
        ).then(res=>{
            setExecutives(res.data.data.filter(each=>each.type !== 'staff'))
            setStaff(res.data.data.filter(each=>each.type == 'staff'))
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            setError(err.message)
        })
    }
    const deleteExecutive = (_id)=>{
        console.log(_id)
        axios.patch(
            `${uri}executives`,
            {_id}
        ).then(res=>{
            fetchData()
            console.log(res.data)
        }).catch((err)=>{
            console.log(err)
        })
    }
    const selectOffice = (officeName, officePhoto)=>{
        values.office = officeName   
        values.photo = officePhoto     
        setDialog(true)
    }
    const pickPhoto = ()=>{
        document.getElementById('photo').click()
    }
    const processPhoto = (e)=>{
        let file = e.target.files[0]
        if (file.type == 'image/png' || file.type == 'image/jpg' || file.type == 'image/jpeg') {
            JSON.stringify(file.size).length >= 7 ? setFileSize(`${Math.ceil(file.size/1000000)}MB`) : setFileSize(`${Math.ceil(file.size/1000)}KB`)
            const fs = new FileReader()
            fs.readAsDataURL(file)
            fs.onload = ()=>{
                values.photo = fs.result
            }
        } else {
            alert('File format not supported')
        }
    }

    return (
        <Fragment>
            <div className='container font-poppins mt-lg-0 mt-5 text-dark'>
                <p className='fw-bold-0 fs-4 text-dark pt-lg-0 pt-2'>
                    Hub Executives
                </p>
                <p className='fs-6 text-dark'>
                    Click on each offices to edit their information
                </p>                
                {
                    isLoading
                    ?
                    <p className='text-info'>Waiting for server...</p>
                    :
                    executives.length !== 0
                    ?
                    <div className='row w-100 mx-auto pb-5'>
                        <NewStaffAdvisers fetchData={fetchData} staff={staff} />
                        <p className='fs-5'>Executives</p>
                        {executives.map((each, i)=>(
                            <div key={i} className='col-lg-3 col-md-6 mb-4'>
                                <div className='card cursor-pointer' onClick={()=>selectOffice(each.office, each.photo)}>
                                    <img src={!each.photo ? BlankImage : each.photo} className='card-img-top' />
                                    <div className='card-body border card-border rounded-4'>
                                        <p className='text-center text-white'>
                                            {!each.fullname ? 'Office Holder' : each.fullname}
                                        </p>
                                        <p className='card-text text-center fst-italic'>
                                            {each.office}
                                        </p>
                                        <p className='card-text text-center my-0 fs-7 fst-italic'>
                                            {each.deptLevel}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    executives.length == 0 && error == ''
                    ?
                    <p className='text-yrh fs-5'>Nothing is here...</p>
                    :
                    <p className='text-danger fs-5'>{error}</p>
                }
            </div>
            {/* Upload Modal */}
            <Dialog open={dialog} maxWidth={'xs'} fullWidth={true} className='font-poppins' >
                <DialogContent>
                    <p className='fs-6 fw-bold-0'>{values.office} </p>
                    <div className='my-4'>
                        <input type='text' onChange={handleChange} onBlur={handleBlur} name='fullname' className={errors.fullname && touched.fullname ? 'is-invalid form-control' : 'form-control'} placeholder='Full Name' />
                    </div>
                    <div className='my-4'>
                        <input type='text' onChange={handleChange} onBlur={handleBlur} name='deptLevel' className={errors.deptLevel && touched.deptLevel ? 'is-invalid form-control' : 'form-control'} placeholder='e.g Zoology, 300L' />
                    </div>
                    <div className='my-4'>
                        <div className='d-flex'>
                            <Button onClick={pickPhoto} className='bg-yrh text-white fw-bold font-poppins'>Photo</Button> <span className='fs-5 px-2 fw-bold-0 text-yrh'>- {fileSize}</span>
                        </div>
                        <input id='photo' type='file' className='d-none form-control' onChange={processPhoto} />
                    </div>                    
                    <Button disabled={isSubmitting} onClick={handleSubmit} className={isSubmitting ? 'fw-bold border border-yrh text-yrh rounded-0 mx-1' : 'fw-bold bg-yrh text-white rounded-0 mx-1'}>
                        {
                            isSubmitting
                            ?
                            'Please wait...'
                            :
                            'Submit'
                        }
                    </Button>
                    <Button disabled={isSubmitting} onClick={()=>setDialog(false)} className='fw-bold bg-light text-dark rounded-0 mx-1'>
                        Cancel
                    </Button>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}

export default NewExecutive